<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Field Form Data Loading...
  </div>

  <div v-else class="animated fadeIn">
    <b-form @submit.prevent="onSubmit">
      <b-card v-for="(v, index) in $v.form_data.$each.$iter" :key="index" no-body>
        <b-card-header class="d-flex justify-content-between align-items-center">
          <span class="text-muted text-uppercase">{{ form_label ? form_label : customer_field ? `Update ${customer_field.name}` : "New Field" }}</span>
          <b-button v-if="form_data.length > 1" variant="danger" size="sm" @click="removeField(index)"><i class="fa fa-trash" /></b-button>
        </b-card-header>

        <div class="py-3 px-5">
          <b-form-group label="Grower" :label-cols="3">
            <b-form-select
              v-model="v.customer_grower_id.$model"
              :options="customer_grower_options"
              :state="!v.customer_grower_id.$invalid"
              invalid-feedback="Required"
              placeholder="Select Grower"
            >
              <template #first>
                <option :value="null" disabled>Select Grower</option>
              </template>
            </b-form-select>
          </b-form-group>

          <b-form-group label="Name" :label-cols="3">
            <b-form-input
              v-model="v.name.$model"
              :state="!v.name.$invalid"
              invalid-feedback="Required"
              placeholder="Name"
              type="text"
            />
          </b-form-group>
        </div>
      </b-card>
      <b-button block variant="success" @click="addField">
        <i class="fa fa-plus" /> Add Column
      </b-button>

      <b-row>
        <b-col>
          <b-button @click="onSubmit" class="my-4 float-right py-3 px-5" variant="success">
            <i class="fal fa-save" /> Save
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import { getCollection } from '@/shared/fetch-utils'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {
  name: "CustomerFieldForm",
  mixins: [validationMixin],
  props: {
    customer_field: {
      type: Object,
      default: null
    },
    form_label: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      customer_id: this.$route.params.customer_id,

      form_data: [
        {
          name: null,
          customer_grower_id: null,
        }
      ],

      customer_grower_collection: [],
      customer_grower_options: [],
      loading: false,
    }
  },
  validations: {
    form_data: {
      required,
      $each: {
        name: { required },
        customer_grower_id: { required }
      }
    }
  },
  created () {
    this.fetchCustomerGrowers()

    if (this.customer_field) {
      this.form_data = [
        {
          name: this.customer_field.name,
          customer_grower_id: this.customer_field.customer_grower_id
        }
      ]
    }
  },
  methods: {
    onSubmit () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.$emit('submit', this.form_data)
      }
    },

    addField () {
      const lastField = this.form_data[this.form_data.length - 1]
      this.form_data.push({
        name: null,
        customer_grower_id: lastField ? lastField.customer_grower_id : null
      })
    },

    removeField (index) {
      this.form_data.splice(index, 1)
    },

    async fetchCustomerGrowers () {
      this.loading = true

      this.customer_grower_collection = await getCollection({
        collection_type: 'customer_grower',
        filters: [
          {
            logic: 'filterEquals',
            field: 'customer.id',
            value: this.customer_id
          }
        ],
        limit: 'all',
        message: this.$bvToast
      })

      this.customer_grower_options = this.customer_grower_collection && this.customer_grower_collection.models.map((grower) => {
        return {
          value: grower.id,
          text: grower.name
        }
      }) || []

      this.loading = false
    },
  }
}
</script>
